import {useId} from 'react';
import {ConfirmFormRow} from '../confirm-form-row';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';
import {type FormSchema} from '@/features/company-registration/form';

type Props = Pick<FormSchema, 'billingInfo'>;

export function ConfirmBillingInformationSection({billingInfo}: Props) {
  const id = useId();
  const formTitleId = `${id}-formTitle`;

  return (
    <section
      aria-labelledby={formTitleId}
      className={companyRegistrationPageStyles.container}
    >
      <div className={companyRegistrationPageStyles.header}>
        <h2
          className={companyRegistrationPageStyles.formTitle}
          id={formTitleId}
        >
          請求情報
        </h2>
      </div>

      <div className={companyRegistrationPageStyles.rows}>
        <ConfirmFormRow labelText='会社名'>
          {billingInfo.companyName}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='請求先住所'>
          <p>
            {billingInfo.zip.slice(0, 3)}-{billingInfo.zip.slice(3)}
          </p>
          <p>{billingInfo.address}</p>
          {billingInfo.address2 && <p>{billingInfo.address2}</p>}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='所属部署'>
          {billingInfo.department}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='氏名'>
          {billingInfo.firstName} {billingInfo.lastName}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='氏名（カナ）'>
          {billingInfo.firstNameKana} {billingInfo.lastNameKana}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='メールアドレス'>
          {billingInfo.email}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='メールアドレス(cc）'>
          {billingInfo.emailCc}
        </ConfirmFormRow>
      </div>
    </section>
  );
}
